/** Spread markers that share the same rounded coordinates so stacked stops remain visible. */
export function spreadStackedMarkerPositions<T extends { lat: number; lng: number }>(
  points: readonly T[],
): Array<T & { displayLat: number; displayLng: number }> {
  const buckets = new Map<string, T[]>();
  for (const point of points) {
    const key = `${point.lat.toFixed(5)}:${point.lng.toFixed(5)}`;
    const bucket = buckets.get(key) ?? [];
    bucket.push(point);
    buckets.set(key, bucket);
  }

  const spread: Array<T & { displayLat: number; displayLng: number }> = [];
  for (const bucket of buckets.values()) {
    if (bucket.length === 1) {
      const point = bucket[0]!;
      spread.push({ ...point, displayLat: point.lat, displayLng: point.lng });
      continue;
    }
    const center = bucket[0]!;
    const radiusMeters = 10;
    const latScale = radiusMeters / 111_320;
    const lngScale = radiusMeters / (111_320 * Math.cos((center.lat * Math.PI) / 180));
    bucket.forEach((point, index) => {
      const angle = (2 * Math.PI * index) / bucket.length;
      spread.push({
        ...point,
        displayLat: center.lat + latScale * Math.cos(angle),
        displayLng: center.lng + lngScale * Math.sin(angle),
      });
    });
  }
  return spread;
}
